import { skuList } from '@/api';
import { FormList, HeaderTitle, Operation, Thumbnails, ExportData } from '@/components';
import { st_auction, st_spu } from '@/utils/statetype';
import { calcPrice, toDateTime } from '@/utils/utils';
import React, { useState } from 'react';
import { useTable } from '@/hooks';
import { Table } from 'antd';

const { typeObj } = st_spu;
const { statusObj: aucStatusObj } = st_auction;
function FinanceSettlement({ history }) {
  const [query, setQuery] = useState({});

  const columns = {
    id: '排期编号',
    NOINDEX_id: {
      title: '商品编号',
      render: ({ Spu }) => {
        const { id } = Spu || {};
        return id || '-';
      },
    },
    NOINDEX_name: {
      title: '商品名称',
      render: ({ Spu }) => {
        const { name } = Spu || {};
        return name || '-';
      },
    },
    NOINDEX_thumb: {
      title: '封面图',
      render: ({ Spu }) => {
        const { thumb } = Spu || {};
        return <Thumbnails images={[thumb]} center />;
      },
    },
    type: {
      title: '排期商品类型',
      render: e => typeObj[e] || '-',
    },
    NOINDEX_Merchant: {
      title: '所属店铺',
      render: ({ Spu }) => {
        const { Merchant = {} } = Spu || {};
        return Merchant.title || '-';
      },
    },
    num: '商品数量',
    status: {
      title: '竞拍状态',
      render: e => aucStatusObj[e],
    },
    offerCount: '出价次数',
    startPrice: {
      title: '起拍价',
      render: e => calcPrice(e),
    },
    finalPrice: {
      title: '最终价',
      render: e => calcPrice(e),
    },
    NOINDEX_times: {
      title: '竞拍时间',
      render: e => {
        const { startTime, endTime } = e;
        return toDateTime(startTime) + ' ~' + toDateTime(endTime);
      },
    },
    createdAt: {
      title: '创建时间',
      render: e => toDateTime(e),
    },
    NOINDEX_operation: {
      title: '操作',
      fixed: 'right',
      render: e => (
        <Operation
          listData={{
            select: () => history.push(`/finance/settlement/detail?i=${e.id}`),
          }}
        />
      ),
    },
  };

  const { tableProps, flagFn } = useTable({
    columns,
    API: skuList,
    isInit: false,
    params: {
      query: {
        ...query,
        status: 110,
      },
    },
  });

  const formData = [
    {
      id: 'name',
      label: '商品名称',
    },
    {
      id: 'merchantId',
      label: '店铺编号',
    },
    {
      id: 'title',
      label: '店铺名称',
    },
    {
      id: 'times',
      label: '竞拍时间',
      type: 'rangeTime',
    },
  ];

  const changeQuery = (value = {}) => {
    const { times, ...props } = value;
    const [start, end] = times || [];
    const q = {
      ...props,
      ...(times && {
        startTime: toDateTime(start),
        endTime: toDateTime(end),
      }),
    };
    setQuery(q);
    flagFn(true);
  };

  return (
    <>
      <HeaderTitle />
      <FormList formData={formData} changeQuery={changeQuery}
        extraRender={
          <ExportData
            title="订单列表"
            API={skuList}
            query={{
              ...query,
              status: 110,
            }}
            // dataParse={excelDataParse}
            extend={{
              type: typeObj,
              status: aucStatusObj,
              startPrice: "amount",
              finalPrice: "amount",
              startTime: "time",
              endTime: "time",
              createdAt: "time",
            }}
            columns={{
              id: '排期编号',
              'Spu.id': '商品编号',
              'Spu.name': '商品名称',
              'Spu.thumb': '封面图',
              type: '排期商品类型',
              'Spu.Merchant.title': '所属店铺',
              num: '商品数量',
              status: '竞拍状态',
              offerCount: '出价次数',
              startPrice: '起拍价',
              finalPrice: '最终价',
              startTime: "竞拍开始时间",
              endTime: "竞拍结束时间",
              createdAt: '创建时间',
            }}
          />
        }
      />
      <Table {...tableProps} />
    </>
  );
}

export default FinanceSettlement;
